module.exports = __webpack_public_path__ + "static/img/music.baf8cd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/music.png
// module id = 6WXs
// module chunks = 53